import { fabric } from 'fabric'
import moment from 'moment'
import React from 'react'
import { ReactComponent as IconAI } from '../assets/images/default/file-ai.svg'
import { ReactComponent as IconDoc } from '../assets/images/default/file-doc.svg'
import { ReactComponent as IconEps } from '../assets/images/default/file-eps.svg'
import { ReactComponent as IconPDF } from '../assets/images/default/file-pdf.svg'
import { ReactComponent as IconPS } from '../assets/images/default/file-ps.svg'
import { ReactComponent as IconXL } from '../assets/images/default/file-xls.svg'
import { ReactComponent as IconFile } from '../assets/images/default/file.svg'

const isToolRequired = (toolName, requiredToolBar) => {
    if (!requiredToolBar || !toolName) {
        return false
    } else {
        return requiredToolBar[toolName]
    }
}

const sortBySerial = (obj) => {
    const order = []
    const res = {}
    Object.keys(obj).forEach((key) => {
        return (order[obj[key].serial - 1] = key)
    })
    order.forEach((key) => {
        res[key] = obj[key]
    })
    return res
}

const sortObjectByDate = (obj) => {
    const keys = Object.keys(obj)
    keys.sort((a, b) => obj[a].serial - obj[b].serial)
    const sortedObj = {}

    for (const key of keys) {
        sortedObj[key] = obj[key]
    }
    return sortedObj
}

const getImageExt = (url) => {
    if (!url) {
        return ''
    }

    const splits = url.split('.')
    let result = ''
    if (splits.length) {
        result = splits[splits.length - 1]
    }
    return result
}

const IMAGE_EXTS = [
    'jpeg',
    'jpg',
    'png',
    'gif',
    'tiff',
    'svg',
    'JPEG',
    'JPG',
    'PNG',
    'GIF',
    'TIFF',
    'SVG'
]

const DOC_EXTS = ['doc', 'docx', 'DOC', 'DOCX']
const XLS_EXTS = ['xls', 'xlsx', 'XLS', 'XLSX']
const PDF_EXTS = ['pdf', 'PDF']
const AI_EXTS = ['ai', 'AI']
const PSD_EXTS = ['ps', 'psd', 'PS', 'PSD']
const EPS_EXTS = ['eps', 'EPS']

const getIconByFileType = (fileType) => {
    switch (fileType) {
        case "DOC":
            return <IconDoc />;
        case "XLX":
            return <IconXL />;
        case "PDF":
            return <IconPDF />;
        case "AI":
            return <IconAI />;
        case "PSD":
            return <IconPS />;
        case "EPS":
            return <IconEps />;
        case "FILE":
            return <IconFile />;
        default:
            return <IconFile />;
    }
}

const getShortName = (source, size = 35) => {
    return source?.length > size ? source?.slice(0, size - 1) + '…' : source
}

const isItemLocked = (canvas) => {
    const activeObj = canvas.getActiveObject()
    return activeObj.locked
}

const getFileType = (fileName) => {
    if (!fileName || fileName.trim().length === 0) return 'NO_FILE'

    const ext = fileName.split('.').pop()

    if (IMAGE_EXTS.includes(ext)) return 'IMAGE'
    else if (DOC_EXTS.includes(ext)) return 'DOC'
    else if (XLS_EXTS.includes(ext)) return 'XLX'
    else if (PDF_EXTS.includes(ext)) return 'PDF'
    else if (AI_EXTS.includes(ext)) return 'AI'
    else if (PSD_EXTS.includes(ext)) return 'PSD'
    else if (EPS_EXTS.includes(ext)) return 'EPS'
    else return 'FILE'
}

const handleGroup = (activeSelection, canvas) => {
    if (!activeSelection) return
    if (canvas.getActiveObject()._objects === undefined) return
    canvas.getActiveObject().toGroup()
    canvas.requestRenderAll()
    canvas.calcOffset()
    canvas.fire('object:modified')
}

const handleUngroup = (activeSelection, canvas) => {
    if (!activeSelection) return
    if (canvas.getActiveObject()._objects === undefined) return
    canvas.getActiveObject().toActiveSelection()
    canvas.requestRenderAll()
    canvas.calcOffset()
    canvas.fire('object:modified')
}

const handleBringFwd = (activeSelection, canvas) => {
    if (isItemLocked(canvas)) return
    if (!activeSelection) return
    activeSelection.forEach((item) => item.bringForward(activeSelection))
    // canvas.discardActiveObject()
    canvas.requestRenderAll()
    canvas.calcOffset()
    canvas.fire('object:modified')
}

const handleBringBack = (activeSelection, canvas) => {
    if (isItemLocked(canvas)) return
    if (!activeSelection) return
    activeSelection.forEach((item) => item.sendBackwards(activeSelection))
    // canvas.discardActiveObject()
    canvas.requestRenderAll()
    canvas.calcOffset()
    canvas.fire('object:modified')
}
let baseLeftOffset
let baseTopOffset

const handleDuplicate = (activeSelection, canvas) => {
    if (isItemLocked(canvas)) return
    if (!activeSelection) return
    const clonedObjects = []
    const activeObjects = canvas.getActiveObjects()
    // console.log('canvas:',canvas)
    //  console.log('canvas_previousPointer:',canvas._previousPointer)

    // let allObjects = JSON.parse(JSON.stringify(canvas.getObjects()))
    //  console.log('allObjects:',allObjects)
    // const originalLeft = allObjects.left
    // const originalTop = allObjects.top

    const _activeObjects = canvas.getActiveObjects()
    const selected_object = canvas.getActiveObjects()
    let clonedObject__ = { ..._activeObjects }
    // console.log('_activeObjects:',_activeObjects)
    // console.log('_activeObjects:',clonedObject__[0].left)
    if (_activeObjects.length === 1) {
        baseLeftOffset = _activeObjects[0].left + 20
        baseTopOffset = _activeObjects[0].top + 20
    }
    if (_activeObjects.length > 1) {
        console.log(
            'canvas-x, y:',
            canvas._previousPointer.x,
            canvas._previousPointer.y
        )
        baseLeftOffset = canvas._previousPointer.x + canvas._offset.left + 20
        baseTopOffset = canvas._previousPointer.y + canvas._offset.top + 20
    }

    const clonedObjectsPromises = _activeObjects.map((obj) => {
        const x = new Promise((resolve) =>
            obj.clone((cloned) => {
                return resolve(cloned)
            })
        )
        console.log('X:', x)
        return x
    })

    Promise.all(clonedObjectsPromises).then((clonedObjects) => {
        //  console.log('clonedObjects:',clonedObjects)
        if (clonedObjects.length === 1) {
            clonedObjects.forEach((clonedObj, index) => {
                clonedObj.set({
                    left: clonedObj.left + 20, // Example offset to prevent overlapping
                    top: clonedObj.top + 20
                })
                canvas.add(clonedObj)
                canvas.setActiveObject(clonedObj)
            })
        } else if (clonedObjects.length > 1) {
            clonedObjects.forEach((clonedObj) => {
                clonedObj.set({
                    // left: clonedObj.left + 20 + canvas._previousPointer.x,
                    // top: clonedObj.top + 20 + canvas._previousPointer.y
                    left: clonedObj.left + baseLeftOffset,
                    top: clonedObj.top + baseTopOffset
                })
                canvas.add(clonedObj)
            })

            const sel = new fabric.ActiveSelection(clonedObjects, {
                canvas: canvas
            })
            canvas.setActiveObject(sel)
        }
        canvas.renderAll() // Render the canvas to display the new objects
        canvas.requestRenderAll()
        canvas.calcOffset()
        canvas.fire('object:modified')
    })

    canvas.requestRenderAll()
    canvas.calcOffset()
    canvas.fire('object:modified')
}

const isMobileDevice = () => {
    const isMobileDevice = localStorage.getItem('isMobileDevice')
    return isMobileDevice === 'true'
}

const getZoomRatio = () => {
    const bodyWidth = document.body.clientWidth
    let value = 1
    if (isMobileDevice()) {
        value = 0.46
    } else if (bodyWidth > 1300 && bodyWidth <= 1400) {
        value = 0.6
    } else if (bodyWidth > 1401 && bodyWidth <= 1550) {
        value = 0.7
    } else if (bodyWidth > 1551 && bodyWidth <= 1900) {
        value = 0.8
    }
    return value
}

const convertDateToLocal = (date, outputFormat = 'DD.MM.YYYY') => {
    return moment.utc(date).local().format(outputFormat)
}

const convertDateTimeToLocal = (
    date,
    time = '',
    outputFormat = 'DD.MM.YYYY'
) => {
    const formattedTime = moment(time, 'HH:mm:ss').format('hh:mm A')
    const formatForUtc =
        moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY') +
        (time ? ' ' + formattedTime : '')
    const convertedDate = moment.utc(formatForUtc).format()
    return moment.utc(date).local().format(outputFormat)
}

// const generateCanvasCount = (canvasMap) => {
//     const numberList = []
//     canvasMap.map((item) => numberList.push(item.substring(8)))
//     return Math.max(...numberList)
// }
const generateCanvasCount = (canvasIds) => {
    // Ensure canvasIds is an array to prevent runtime errors
    if (!Array.isArray(canvasIds) || canvasIds.length === 0) return 0

    const numberList = canvasIds.map((item) => parseInt(item.substring(8), 10))
    return Math.max(...numberList)
}

const handleLock = (activeSelection, canvas) => {
    if (!activeSelection) return
    const selectedObjects = canvas.getActiveObject()._objects
        ? canvas.getActiveObject()._objects
        : activeSelection
    selectedObjects?.forEach((item) => {
        if (item.stroke) item.oldStroke = item.stroke
        if (item.strokeWidth) item.oldStrokeWidth = item.strokeWidth
        item.selectable = false
        item.hasControls = false
        item.lockMovementX = true
        item.lockMovementY = true
        item.locked = true
    })
    canvas?.discardActiveObject()
    canvas.requestRenderAll()
    canvas.calcOffset()
    canvas.fire('object:modified')
}
const handleUnLock = (activeSelection, canvas) => {
    if (!activeSelection) {
        canvas._objects.forEach((item) => {
            if (item.locked && item.isLockedSelected) {
                item.locked = false
                item.isLockedSelected = false
                item.selectable = true
                item.hasControls = true
                item.hasBorders = true
                item.lockMovementX = false
                item.lockMovementY = false
                if (item.oldStroke !== null && item.oldStroke !== undefined) {
                    item.stroke = item.oldStroke
                    item.strokeWidth = item.oldStrokeWidth
                } else {
                    item.strokeWidth = 0
                    item.stroke = ''
                }
            }
        })
    }
    canvas.requestRenderAll()
    canvas.calcOffset()
    canvas.fire('object:modified')
}

const getCanvasLeftSpace = (canvas, canvasList, changeCanvasLeftSpace) => {
    let canvasLeft = canvasList[canvas.getElement().id].canvasLeft
    const canvasUsedWidth = canvasList[canvas.getElement().id].canvasUsedWidth
    const width = canvas.getWidth()
    let leftValue
    if (canvasUsedWidth === 0) {
        leftValue = 80
    } else if (width - canvasUsedWidth > 680) {
        leftValue = 80 + canvasUsedWidth + 400
    } else {
        leftValue = 80
    }
    changeCanvasLeftSpace(
        canvas.getElement().id,
        (canvasLeft += 500),
        leftValue
    )

    return canvasLeft
}

let _clipboard = null
let _clipCanvasId = null
let _obj = null

const copy = (canvas, isMarkToolRelease) => {
    if (isMarkToolRelease) {
        if (window.getSelection().toString()?.length > 0) {
            navigator.clipboard.writeText(window.getSelection().toString())
        }
        return
    }
    if (canvas?.getActiveObject()) {
        if (!canvas?.getActiveObject()?.isEditing) {
            //   console.log('IsEditing')
            navigator.clipboard.writeText('').then(() => {
                canvas.getActiveObject()?.clone(function (cloned) {
                    //   copyToIndexedDB(cloned)
                    // const jsonString = JSON.stringify(cloned);
                    // const sizeInBytes = new TextEncoder().encode(jsonString).length;
                    // console.log(sizeInBytes, "bytes");

                    const jsonString = JSON.stringify(cloned)
                    const encodedData = btoa(jsonString)
                    localStorage.setItem('copyData', encodedData)

                    _clipCanvasId = canvas.getElement().id
                    _clipboard = cloned
                })
            })
        } else {
            _clipboard = null
            _clipCanvasId = null
            const obj = canvas?.getActiveObject()

            if (obj && obj.isType('textbox')) {
                const { text } = obj
                navigator.clipboard.writeText(text)
            }
        }
    }
}

const cut = async (canvas) => {
    if (canvas?.getActiveObject()) {
        navigator.clipboard.writeText('').then(() => {
            canvas.getActiveObject()?.clone(function (cloned) {
                _clipCanvasId = canvas.getElement().id
                _clipboard = cloned
                canvas.getActiveObjects().forEach((obj) => {
                    canvas.remove(obj)
                })

                canvas?.discardActiveObject().requestRenderAll()
                canvas.calcOffset()
                canvas.fire('object:modified')
            })
        })
    }
}

const isValidUrl = (urlString) => {
    const urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // validate protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
            '(\\#[-a-z\\d_]*)?$',
        'i'
    ) // validate fragment locator
    return !!urlPattern.test(urlString)
}
// const paste = async (canvas, isMarkToolRelease) => {
//     console.log('Paste');
//     if (isMarkToolRelease) return;
//     if (canvas?.getActiveObject()?.isEditing) return;

//     // Retrieve and parse the clipboard data from localStorage
//     const clipboardData = localStorage.getItem('canvasClipboard');
//     if (!clipboardData) return;

//     const { type, data } = JSON.parse(clipboardData);
//     console.log('clipboardDataLocalStorage:', clipboardData);

//     try {
//         // Handle pasting for image data
//         if (type === 'image') {
//             fabric.Image.fromURL(data, (img) => {
//                 img.set({ left: 200, top: 200 });
//                 img.scaleToHeight(400);
//                 img.scaleToWidth(400);
//                 canvas.centerObject(img);
//                 canvas.add(img);
//                 canvas.requestRenderAll();
//             }, { crossOrigin: 'Anonymous' });
//         }
//         // Handle pasting for JSON object data
//         else if (type === 'text/plain') {
//             fabric.util.enlivenObjects([JSON.parse(data)], (objects) => {
//                 objects.forEach((obj) => {
//                     obj.set({ left: obj.left + 10, top: obj.top + 10 });
//                     canvas.add(obj);
//                 });
//                 canvas.requestRenderAll();
//             });
//         }
//     } catch (e) {
//         console.error('Paste error:', e);
//     }
// };
const paste = async (canvas, isMarkToolRelease) => {
    const clipboardData = localStorage.getItem('canvasClipboard')
    // console.log('clipboardDataLocalStorage:',clipboardData)

    if (isMarkToolRelease) return
    if (canvas?.getActiveObject()?.isEditing) return

    try {
        const clipboardContents = await navigator.clipboard.read()
        //  console.log('clipboardContents:', clipboardContents)
        for (const item of clipboardContents) {
            // console.log('Item:', item)
            if (item.types.includes('image/png')) {
                //   console.log('Item-image:', item)
                _clipboard = null
                const blob = await item.getType('image/png')
                // console.log('blob:', blob)
                if (!(blob instanceof Blob)) {
                    //   console.log('item:', item)
                    if (item.types.includes('text/plain')) {
                        const svgText = await item.getType('text/plain')
                        //     console.log('tsvgText:',svgText)
                        svgText.text().then((svg) => {
                            fabric.loadSVGFromString(
                                svg,
                                (objects, options) => {
                                    const svgObj = fabric.util.groupSVGElements(
                                        objects,
                                        options
                                    )
                                    svgObj
                                        .set({ left: 200, top: 200 })
                                        .scale(0.5)
                                    svgObj.scaleToHeight(400)
                                    svgObj.scaleToWidth(400)

                                    canvas.add(svgObj)
                                    canvas.requestRenderAll()
                                }
                            )
                        })
                        canvas.requestRenderAll()
                        canvas.calcOffset()
                        canvas.fire('object:modified')
                    }

                    console.log('The item is not a Bolb object')
                    return
                }
                const reader = new FileReader()
                reader.readAsDataURL(blob)
                reader.onloadend = function () {
                    const base64data = reader.result

                    //   console.log('base64data:', base64data)
                    fabric.Image.fromURL(
                        base64data,
                        (img) => {
                            img.set({ left: 200 })
                            img.scaleToHeight(400)
                            img.scaleToWidth(400)
                            canvas.centerObjectV(img)
                            canvas.add(img)
                        },
                        { crossOrigin: 'Anonymous' }
                    )
                }
                canvas.requestRenderAll()
                canvas.calcOffset()
                canvas.fire('object:modified')
            }
            if (
                item.types.includes('text/plain') &&
                !item.types.includes('text/html') &&
                !item.types.includes('image/png')
            ) {
                //    console.log('text/plain')
                const svgText = await item.getType('text/plain')
                console.log('tsvgText:', svgText)
                svgText.text().then((svg) => {
                    fabric.loadSVGFromString(svg, (objects, options) => {
                        const svgObj = fabric.util.groupSVGElements(
                            objects,
                            options
                        )
                        svgObj.set({ left: 200, top: 200 }).scale(0.5)
                        svgObj.scaleToHeight(400)
                        svgObj.scaleToWidth(400)

                        canvas.add(svgObj)
                        canvas.requestRenderAll()
                    })
                })
                canvas.requestRenderAll()
                canvas.calcOffset()
                canvas.fire('object:modified')

                //First virsion
                // const text = await item.getType('text/plain');
                // const reader = new FileReader();
                // reader.onload = async (e) => {
                //     const content = e.target.result;

                //     // Check if content is SVG
                //     if (content.includes('<svg')) {
                //         fabric.loadSVGFromString(content, (objects, options) => {
                //             console.log('Content:', content)
                //             console.log('objects:', objects)
                //             console.log('options:', options)
                //            const loadedObjects = fabric.util.groupSVGElements(objects, options);
                //             loadedObjects.set({
                //                 left: 200,
                //                 top: 200,
                //             }).scale(0.5);

                //             // If you want to add objects individually instead of as a group:
                //             objects.forEach((obj) => {
                //                 // Set object as selectable and with controls.
                //                 obj.set({
                //                     // left: 200,
                //                     // top: 200,
                //                     scaleX: 0.5,
                //                     scaleY: 0.5,
                //                     cornerSize: 12, // Adjusts the size of the control corners
                //                     transparentCorners: false,
                //                     cornerColor: 'blue',
                //                     borderColor: 'red',
                //                     hasControls: true, // Enables controls
                //                     hasBorders: true, // Enables borders
                //                 });

                //                 canvas.add(obj);
                //                 // This is necessary to update the canvas and the added objects' controls
                //                 obj.setCoords();
                //             });

                //             canvas.requestRenderAll();
                //         });
                //     }
                // };
                // reader.readAsText(text);
            }
            if (item.types.includes('text/html')) {
                //   console.log('text/html')
                const blob = await item.getType('text/html')
                readBlobAsText(blob, processHtmlContent)
                break // Assum
            } else if (item?.types?.length === 0) {
                navigator.clipboard.readText().then(
                    (data) => {
                        //   console.log('Data:', data)
                        if (data === '') {
                            // console.log('Data:::', data)
                            // console.log('_clipboard:::', _clipboard)
                            const encodedData = localStorage.getItem('copyData')
                            //    console.log('encodedData:', encodedData)

                            if (_clipboard) {
                                _clipboard.clone(function (clonedObj) {
                                    //    console.log('clonedObj:', clonedObj)
                                    canvas?.discardActiveObject()
                                    clonedObj.set({
                                        left: clonedObj.left + 10,
                                        top: clonedObj.top + 10,
                                        evented: true
                                    })
                                    if (clonedObj.type === 'activeSelection') {
                                        // active selection needs a reference to the canvas.
                                        clonedObj.canvas = canvas
                                        clonedObj.forEachObject(function (obj) {
                                            canvas.add(obj)
                                        })
                                        // this should solve the unselectability
                                        clonedObj.setCoords()
                                    } else {
                                        canvas.add(clonedObj)
                                    }
                                    _clipboard.top += 10
                                    _clipboard.left += 10

                                    canvas.setActiveObject(clonedObj)
                                    canvas.requestRenderAll()
                                    canvas.calcOffset()
                                    canvas.fire('object:modified')
                                })
                            } else if (encodedData) {
                                //console.log('encodedData:', encodedData);
                                try {
                                    // Decode from base64 and parse the JSON string
                                    const jsonString = atob(encodedData)
                                    const obj = JSON.parse(jsonString)
                                    // console.log('Parsed Object:', obj);

                                    // Recreate the fabric object from the parsed object
                                    fabric.util.enlivenObjects(
                                        [obj],
                                        function (objects) {
                                            //   console.log('objects:', objects);
                                            var loadedObject = objects[0]
                                            baseLeftOffset =
                                                loadedObject.left +
                                                loadedObject.height +
                                                10
                                            ;(baseTopOffset =
                                                loadedObject.top + 10),
                                                // console.log('loadedObject:', loadedObject);
                                                // canvas.discardActiveObject()
                                                loadedObject.set({
                                                    left:
                                                        loadedObject.left + 10,
                                                    top: loadedObject.top + 10,
                                                    evented: true
                                                })

                                            // If it's an active selection, similar logic as your _clipboard handling
                                            if (
                                                loadedObject.type ===
                                                'activeSelection'
                                            ) {
                                                loadedObject.canvas = canvas
                                                loadedObject.forEachObject(
                                                    function (obj) {
                                                        canvas.add(obj)
                                                    }
                                                )
                                                loadedObject.setCoords()
                                            } else {
                                                canvas.add(loadedObject)
                                            }

                                            // Here you might adjust the original object's properties if needed
                                            // For example, if you need to keep track of positions in the original object
                                            // obj.top += 10; // Adjust the obj if needed
                                            // obj.left += 10; // Adjust the obj if needed

                                            canvas.setActiveObject(loadedObject)
                                            canvas.requestRenderAll()
                                            canvas.calcOffset()
                                            canvas.fire('object:modified')
                                        }
                                    )
                                } catch (error) {
                                    console.error(
                                        'Error parsing object:',
                                        error
                                    )
                                }
                            }
                        } else {
                            if (
                                isValidUrl(data) &&
                                data.match(/\.(jpeg|jpg|gif|png)$/) != null
                            ) {
                                fabric.Image.fromURL(
                                    `${data}?x-${
                                        Math.floor(Math.random() * 1000000000) +
                                        1
                                    }=html`,
                                    (img) => {
                                        img.set({ left: 200 })
                                        img.scaleToHeight(400)
                                        img.scaleToWidth(400)
                                        canvas.centerObjectV(img)
                                        canvas.add(img)
                                    },
                                    { crossOrigin: 'Anonymous' }
                                )
                                canvas.requestRenderAll()
                                canvas.calcOffset()
                                canvas.fire('object:modified')
                            }
                        }
                    },
                    (err) => {
                        console.log(err)
                    }
                )
            }
        }
    } catch (e) {
        console.log(e)
    }
}

function readBlobAsText(blob, callback) {
    const reader = new FileReader()
    reader.onloadend = function (e) {
        if (e.target.readyState === FileReader.DONE) {
            // Check if reading completed
            const content = e.target.result
            callback(content)
        }
    }
    reader.onerror = function (e) {
        console.error('Error reading blob:', e)
    }
    reader.readAsText(blob)
}
function processHtmlContent(htmlContent) {
    // Extract SVG or other content from the HTML, and render it
    console.log('HTML Content:', htmlContent)
    // Additional processing here...
}

const isDeviceIsMac = () => {
    const platform = navigator.userAgentData?.platform
    return platform === 'macOS'
}

const removeUnwantedText = (fabricCanvas) => {
    fabricCanvas?.getObjects()?.forEach((item) => {
        if (item.text === 'Your text goes here...') {
            fabricCanvas.remove(item)
        }
    })
}

const _getKey = () => {
    return (
        Math.floor(Math.random() * 10000000) +
        Math.floor(Math.random() * 10000000)
    )
}

export {
    IMAGE_EXTS,
    _getKey,
    convertDateTimeToLocal,
    convertDateToLocal,
    copy,
    cut,
    generateCanvasCount,
    getCanvasLeftSpace,
    getFileType,
    getIconByFileType,
    getImageExt,
    getShortName,
    getZoomRatio,
    handleBringBack,
    handleBringFwd,
    handleDuplicate,
    handleGroup,
    handleLock,
    handleUnLock,
    handleUngroup,
    isDeviceIsMac,
    isItemLocked,
    isMobileDevice,
    isToolRequired,
    paste,
    removeUnwantedText,
    sortBySerial,
    sortObjectByDate
}
